import classNames from 'classnames/bind';
import { nanoid } from 'nanoid';

import { FormError } from 'containers/forms/FormError';

import { Message } from './Message';

import s from './TextArea.module.scss';

const c = classNames.bind(s);

type TProps = {
  floatLabel?: boolean;
  label?: string;
  message?: string;
  error?: boolean;
  required?: boolean;
};

export const TextArea = ({
  className,
  label,
  message,
  error,
  floatLabel = true,
  id,
  rows = 5,
  required,
  ...rest
}: TProps & React.TextareaHTMLAttributes<HTMLTextAreaElement>) => {
  const textareaId = id ?? nanoid(10);
  const renderedLabel = required && label ? `${label} *` : label;

  return (
    <div
      className={c(s.textArea, className, {
        hasLabel: typeof renderedLabel === 'string' && renderedLabel.length > 0,
        error,
        hideFloatLabel: !floatLabel,
      })}
    >
      <label className={s.textArea__label} htmlFor={textareaId}>
        {renderedLabel}
      </label>
      <textarea
        rows={rows}
        className={c(s.textArea__textArea)}
        id={textareaId}
        placeholder={typeof label === 'string' ? label : undefined}
        aria-describedby={message ? `${textareaId}-error` : ''}
        {...rest}
        autoComplete="off"
      />
      {message && <Message id={`${textareaId}-error`}>{message}</Message>}
      {rest.name && <FormError name={rest.name} placeholder={label} />}
    </div>
  );
};
